import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    sharesEquity: "50000",
    incomeAssets: "20000",
    cashAccounts: "30000",
    estateValue: "20000",
    goldJewelry: "20000",
    otherAssets: "20000",
    homeLoans: "50000",
    otherLoans: "25000",
    incomeTaxLonas: "20000",
    billsPayments: "50000",
    creditCardDues: "20000",
    otherLiabilities: "20000",
    netWorth: "0",
    totalAssets: 0,
    totalLiabilities: 0,
    networthErrors: null
};

const networthSlice = createSlice({
    name: "networthCalculator",
    initialState: initialState,

    reducers: {
        setSharesEquity: (state, action) => {
            state.sharesEquity = action.payload;
        },
        setIncomeAssets: (state, action) => {
            state.incomeAssets = action.payload;
        },
        setCashAccounts: (state, action) => {
            state.cashAccounts = action.payload;
        },
        setEstateValue: (state, action) => {
            state.estateValue = action.payload;
        },
        setGoldJewelry: (state, action) => {
            state.goldJewelry = action.payload;
        },
        setOtherAssets: (state, action) => {
            state.otherAssets = action.payload;
        },
        setHomeLoans: (state, action) => {
            state.homeLoans = action.payload;
        },
        setOtherLoans: (state, action) => {
            state.otherLoans = action.payload;
        },
        setIncomeTaxLonas: (state, action) => {
            state.incomeTaxLonas = action.payload;
        },
        setBillsPayments: (state, action) => {
            state.billsPayments = action.payload;
        },
        setCreditCardDues: (state, action) => {
            state.creditCardDues = action.payload;
        },
        setOtherLiabilities: (state, action) => {
            state.otherLiabilities = action.payload;
        },
        setNetWorth: (state, action) => {
            state.netWorth = action.payload;
        },
        setTotalAssets: (state, action) => {
            state.totalAssets = action.payload;
        },
        setTotalLiabilities: (state, action) => {
            state.totalLiabilities = action.payload;
        },
        resetNetworthData: (state) => {
              return initialState;
            },

    }
});



export const { 
    setSharesEquity, setIncomeAssets, setCashAccounts, setEstateValue,
    setGoldJewelry, setOtherAssets, setHomeLoans, setOtherLoans,
    setBillsPayments, setCreditCardDues, setOtherLiabilities, setNetWorth,setIncomeTaxLonas,resetNetworthData,setTotalAssets,setTotalLiabilities
} = networthSlice.actions;

export default networthSlice.reducer;
export const { setActiveCalculater } = networthSlice.actions;
